export const guests = [

  {
    id: 0,
    name: 'Daniel Miller',
    position: 'Co-Founder @ The Coolest People We Know',
    title: '',
    subtitle: '',
    speakingDate: '2020-04-03',
    linkedinURL: 'https://www.linkedin.com/in/danielmillerxy3/',
    photoFileName: 'daniel_miller.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#988BE5;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 1,
    name: 'Jake Pimental',
    position: 'Founder and CEO @ swaymetrics',
    title: '',
    subtitle: '',
    speakingDate: '2020-04-05',
    linkedinURL: 'https://www.linkedin.com/in/jake-pimental/',
    photoFileName: 'jake_Pimental.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#897AE1;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 2,
    name: 'Maryna Burushkina',
    position: 'Founder & CEO @ GrowthChannel',
    title: '',
    subtitle: '',
    speakingDate: '2020-04-09',
    linkedinURL: 'https://www.linkedin.com/in/mburushkina/',
    photoFileName: 'maryna_b.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#7B69DD;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 3,
    name: 'Jacob Peters',
    position: 'Building community tools – CoFounder @ Commsor',
    title: '',
    subtitle: '',
    speakingDate: '2020-04-15',
    linkedinURL: 'https://www.linkedin.com/in/jacobdpeters/',
    photoFileName: 'jacob_peters.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#6C59D9;box-shadow: 2px 10px 15px grey;',

  },
    {
    id: 4,
    name: 'Al Chen',
    position: 'Solutions Architect @ Coda',
    title: 'Content that showcases your product',
    subtitle:
      'Building templates that act as case studies, Keyword research & Embracing LinkedIn for B2B content',
    speakingDate: '2020-04-16',
    linkedinURL: 'https://www.linkedin.com/in/thealchen/',
    photoFileName: 'al_chen.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
      speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#5D48D5;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 5,
    name: 'Maya Grossman',
    position: 'Head of Marketing @ AnD Ventures',
    title: 'How to design the (marketing) career of your dreams',
    subtitle: 'How to: 1. figure out what you want to do next 2. Identify gaps 3. Gain Experience 4. Build a career roadmap and execute',
    speakingDate: '2020-04-20',
    linkedinURL: 'https://www.linkedin.com/in/mayagrossman/',
    photoFileName: 'maya_grossman.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#4F37D2;box-shadow: 2px 10px 15px grey;',


  },
  {
    id: 6,
    name: 'Ann Gynn',
    position:
      'Content Marketing, PR Consulting & Training @ G Force Communication',
    title: 'Content Marketing Strategies',
    subtitle: 'From a member of the Content Marketing Institute',
    speakingDate: '2020-04-21',
    linkedinURL: 'https://www.linkedin.com/in/anngynn/',
    photoFileName: 'ann_gynn.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#442DC8;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 7,
    name: 'Katie Berry',
    position: 'Director, Agency Relations @ U.S. Bank',
    title: 'How Large Banks Market Amid Crisis',
    subtitle: 'Volunteering and other ways you can garner support for your business and community',
    speakingDate: '2020-04-22',
    linkedinURL: 'https://www.linkedin.com/in/katiecberry/',
    photoFileName: 'katie_berry.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#3F2AB7;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 8,
    name: 'Inbar Yagur',
    position: 'Head of Product Marketing @ Keywee',
    title: 'Arm yourself with data for B2B content marketing',
    subtitle: 'Understand your audience`s mindset with #s',
    speakingDate: '2020-04-23',
    linkedinURL: 'https://www.linkedin.com/in/inbaryagur/',
    photoFileName: 'inbar.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#3926A6;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 9,
    name: 'Brent Summers',
    position: 'Director of Marketing @ Blink',
    title: 'The UX Flywheel',
    subtitle: 'How UX strategy enables successful marketing teams',
    speakingDate: '2020-04-24',
    linkedinURL: 'https://www.linkedin.com/in/brentjsummers/',
    photoFileName: 'brent_s.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#332296;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 10,
    name: 'Simon Hawk',
    position: 'UX & Brand Optimization @ Puerto Rico',
    title: '',
    subtitle: '',
    speakingDate: '2020-04-27',
    linkedinURL: 'https://www.linkedin.com/in/simonhawk/',
    photoFileName: 'simon_hawk.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#2E1E85;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 11,
    name: 'Jonathan Kranz',
    position: 'Author of Writing Copy for Dummies',
    title: 'How to use persona insights to craft messages that are ruthlessly relevant to your markets',
    subtitle: '',
    speakingDate: '2020-04-28',
    linkedinURL: 'https://www.linkedin.com/in/jonathankranz/',
    photoFileName: 'jon_kranz.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#281A74;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 12,
    name: 'Pam Didner',
    position: 'Author, Instructor, Marketer',
    title: '5 Creative Ways Marketers Can Enable Their Sales Teams',
    subtitle: '',
    speakingDate: '2020-04-29',
    linkedinURL: 'https://www.linkedin.com/in/pamdidner/',
    photoFileName: 'pam_didner.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#221764;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 13,
    name: 'Chris Luecke',
    position: 'Podcast Host & Founder @ Company NamePubcast Worldwide',
    title: '',
    subtitle: '',
    speakingDate: '2020-04-30',
    linkedinURL: 'https://www.linkedin.com/in/cwluecke/',
    photoFileName: 'chris_l.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#1D1353;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 14,
    name: 'Bertrand Cocallemen',
    position: 'Global VP, Creative Strategy @ Teads',
    title: '',
    subtitle: '',
    speakingDate: '2020-05-02',
    linkedinURL: 'https://www.linkedin.com/in/cocallemen/',
    photoFileName: 'bertrand_coco.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#110B32;box-shadow: 2px 10px 15px grey;',


  },
  {
    id: 15,
    name: 'Christoph Trappe',
    position:
      'Chief Content & Marketing Officer @ The Authentic Storytelling Project',
    title: 'How to make content performance easier',
    subtitle: '',
    speakingDate: '2020-05-01',
    linkedinURL: 'https://www.linkedin.com/in/christophtrappe/',
    photoFileName: 'chris_trappe2.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#170F43;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 16,
    name: 'Yash Shah',
    position: 'Co-Founder @ Gridle',
    title: 'Insights from Running an Incubator',
    subtitle: '',
    speakingDate: '2020-05-04',
    linkedinURL: 'https://www.linkedin.com/in/yashparallel/',
    photoFileName: 'yash_p.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#0B0821;box-shadow: 2px 10px 15px grey;',

  },
    {
    id: 17,
    name: 'Taylor Ryan',
    position: 'Founder, CEO @ Klint Marketing',
    title: 'Marketing with Bootstrapped Methodologies in Quarantine',
    subtitle: '',
    speakingDate: '2020-05-05',
    linkedinURL: 'https://www.linkedin.com/in/taylorryan/',
    photoFileName: 'taylor_ryan.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '/resources/unconventional-marketing/marketing-with-bootstrapped-methodologies-in-quarantine-taylor-ryan',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: 'https://www.alphavoice.io/video/ama-marketing-sales-growth/masters-of-marketing-35-marketing-with-bootstrapped-methodologies-in-quarantine-w-taylor-ryan',
    previewAV:'',
    cardColor: 'background-color:#060411;box-shadow: 2px 10px 15px grey;',
    trimColor: ''

  },
    {
    id: 18,
    name: 'Shep Hyken',
    position: 'Chief Amazement Officer @ Shepard Presentations',
    title: '6 Principels of Customer Experience',
    subtitle: '',
    speakingDate: '2020-05-08',
    linkedinURL: 'https://www.linkedin.com/in/shephyken/',
    photoFileName: 'shep_h.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
      speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#0B0821;box-shadow: 2px 10px 15px grey;',

  },
  {
    id: 19,
    name: 'Nikki Elbaz',
    position: 'Sr. Email copywriter, Co-founder @ Copyhackers, Unmassmarket',
    title: 'Best practices are killing your email marketing results',
    subtitle: '',
    speakingDate: '2020-05-18',
    linkedinURL: 'https://www.linkedin.com/in/nikki-elbaz/',
    photoFileName: 'Nikki_Elbaz.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '/resources/email/supercharge-your-email-sending-practices-with-copy-hacker-nikki-elbaz',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#110B32;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 20,
    name: 'Paxton Gray',
    position: 'CEO @ 97th Floor',
    title: 'Understand Your Market To Change Lives And Make Raving Fans',
    subtitle: '',
    speakingDate: '2020-05-19',
    linkedinURL: 'https://www.linkedin.com/in/paxtongray/',
    photoFileName: 'Paxton_Gray.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#170F43;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 21,
    name: 'Donatas Jonikas',
    position: 'Founder, Startup Marketing Advisor @ Marketing Algorithms, JSC',
    title: 'How to leverage win-win partnerships in marketing?',
    subtitle: '',
    speakingDate: '2020-05-20',
    linkedinURL: 'https://www.linkedin.com/in/jonikas/',
    photoFileName: 'Donatas_Jonikas.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#1D1353;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 22,
    name: 'Melanie Deziel',
    position: 'Chief Content Officer @ StoryFuel',
    title: 'Content Marketing Like A Journalist',
    subtitle: '',
    speakingDate: '2020-05-21',
    linkedinURL: 'https://www.linkedin.com/in/melaniedeziel/',
    photoFileName: 'Melanie_Deziel.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#221764;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 23,
    name: 'Eric Vardon',
    position: 'CEO, Co-Founder @ Morphio',
    title: 'AI & Marketing',
    subtitle: '',
    speakingDate: '2020-05-26',
    linkedinURL: 'https://www.linkedin.com/in/ericvardon/',
    photoFileName: 'Eric_Vardon.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    cardColor: 'background-color:#281A74;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 24,
    name: 'Craig Zingerline',
    position: 'Chief Product Officer @ Sandboxx',
    title: 'Building Proper Experiments',
    subtitle: '',
    speakingDate: '2020-05-27',
    linkedinURL: 'https://www.linkedin.com/in/craigzingerline/',
    photoFileName: 'Craig_Zingerline.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '/speakers/craig-zingerline',
    presentationPage: '',
    eventBrite: 'https://www.eventbrite.com/e/how-to-build-a-proper-growth-experiment-tickets-106395748548',
    presentationYT: '',
    previewYT: 'https://www.youtube.com/embed/vfWVStrRJH0',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#2E1E85;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://zoom.us/webinar/register/4015900883467/WN_amII22BgS2C0_NlExIbqFw'
  },
  {
    id: 25,
    name: 'Deirdre Breakenridge',
    position: 'CEO @ Pure Performance Communications',
    title: 'A FEEL Approach in Communication Matters',
    subtitle: '',
    speakingDate: '2020-05-28',
    linkedinURL: 'https://www.linkedin.com/in/deirdrebreakenridge/',
    photoFileName: 'Deirdre_Breakenridge.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    presentationPage: '',
    speakerPage: '/speakers/deirdre-breakenridge',
    eventBrite: 'https://www.eventbrite.com/e/a-feel-approach-in-communication-matters-tickets-106424003058',
    presentationYT: '',
    previewYT: 'https://www.youtube.com/embed/hinuQvBl6GM',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#332296;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://zoom.us/webinar/register/7515901563520/WN_amII22BgS2C0_NlExIbqFw'
  },
  {
    id: 26,
    // Required
    name: 'Andrea Freyrear',
    position: 'Agile Marketing Coach & Trainer @ AgileSherpas',
    title: 'Agile Marketing for the Win',
    speakingDate: '2020-06-01',
    linkedinURL: 'https://www.linkedin.com/in/afryrear/',
    photoFileName: 'andrea_fryrear.jpeg',
    zoomTracking: 'https://zoom.us/webinar/register/5615901563760/WN_amII22BgS2C0_NlExIbqFw',
    // Need All for Signup Page
    speakerPage: '',
    previewYT: '',
    eventBrite: '',
    previewAV:'',
    // SKIP (Program will set these)
    cardColor: 'background-color:#3926A6;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    subtitle: '',
    // Post Presentation Optional
    presentationPage: '',
    presentationYT: '',
    presentationAV: '',
  },
  {
    id: 27,
    name: 'Benyamin Elias',
    position: 'Director, Content Marketing @ ActiveCampaign',
    title: 'Immediately Actionable Content Insights',
    subtitle: '',
    speakingDate: '2020-06-02',
    linkedinURL: 'https://www.linkedin.com/in/benyamin-elias-5b1b0396/',
    photoFileName: 'benyamin.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#3F2AB7;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://zoom.us/webinar/register/8315901563834/WN_amII22BgS2C0_NlExIbqFw'
  },
  {
    id: 28,
    name: 'Zontee Hou',
    position: 'President & Chief Strategist @ Media Volery',
    title: 'Pivoting to Virtual: Taking Events Online',
    subtitle: '',
    speakingDate: '2020-06-03',
    linkedinURL: 'https://www.linkedin.com/in/zonteehou/',
    photoFileName: 'zontee-hou.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '/resources/events/pivoting-to-virtual-events-zontee-hou',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: 'https://www.alphavoice.io/video/ama-marketing-sales-growth/masters-of-marketing-11-the-blue-ocean-strategy-with-jake-pimental',
    previewAV:'',
    cardColor: 'background-color:#442DC8;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://zoom.us/webinar/register/9515901563892/WN_amII22BgS2C0_NlExIbqFw'
  },
    {
    id: 29,
    name: 'Ruthie Bowles',
    position: 'Marketing Consultant | Speaker | Writer',
    title: '',
    subtitle: '',
    speakingDate: '2020-06-04',
    linkedinURL: 'https://www.linkedin.com/in/ruthie-bowles/',
    photoFileName: 'ruthie_bowles.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#4F37D2;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://zoom.us/webinar/register/5415901563951/WN_amII22BgS2C0_NlExIbqFw'
  },
  {
    id: 30,
    name: 'Ashley Zeckman',
    position: 'Senior Director of Digital Strategy @ TopRank Marketing',
    title: 'The New Era of Influencer Marketing',
    subtitle: '',
    speakingDate: '2020-06-08',
    linkedinURL: 'https://www.linkedin.com/in/ashleyzeckman/',
    photoFileName: 'ashley_z.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#5D48D5;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://zoom.us/webinar/register/7015901564091/WN_amII22BgS2C0_NlExIbqFw'
  },

  {
    id: 31,
    name: 'Your Name Here',
    position: 'Marketing Mastermind / Data Whiz',
    title: 'Apply to speak - Season premiers October 1st',
    subtitle: '',
    speakingDate: '2020-10-01',
    linkedinURL: '',
    photoFileName: 'question-man.jpg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#1D1353;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://calendly.com/rosse/marketing-presentation-prescreen'
  },
    {
    id: 32,
    name: 'Your Name Here',
    position: 'Marketing Mastermind / Data Whiz',
    title: 'Apply to speak - Season premiers October 1st',
    subtitle: '',
    speakingDate: '2020-10-02',
    linkedinURL: '',
    photoFileName: 'question-man.jpg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: '',
    presentationPage: '',
    eventBrite: '',
    presentationYT: '',
    previewYT: '',
    presentationAV: '',
    previewAV:'',
    cardColor: 'background-color:#160F40;box-shadow: 2px 10px 15px grey;',
    trimColor: '',
    zoomTracking: 'https://calendly.com/rosse/marketing-presentation-prescreen'
  },
    //Season 2



  // {
  //   id: 26,
  //   // Required
  //   name: 'Andrea Freyrear',
  //   position: 'Agile Marketing Coach & Trainer @ AgileSherpas',
  //   title: 'Agile Marketing for the Win',
  //   speakingDate: '2020-06-01',
  //   linkedinURL: 'https://www.linkedin.com/in/afryrear/',
  //   photoFileName: 'andrea_fryrear.jpeg',
  //   zoomTracking: 'https://zoom.us/webinar/register/5615901563760/WN_amII22BgS2C0_NlExIbqFw'
  //   // Need All for Signup Page
  //   speakerPage: '',
  //   previewYT: '',
  //   eventBrite: '',
  //   previewAV:'',
  //   // SKIP (Program will set these)
  //   cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
  //   trimColor: '',
  //   datePretty: '',
  //   daysLeft: 1,
  //   speakerStatus: 2,
  //   subtitle: '',
  //   // Post Presentation Optional
  //   presentationPage: '',
  //   presentationYT: '',
  //   presentationAV: '',
  // }


]

export const yourHosts = [
  {
    id: 1,
    name: 'Ross Gates',
    position: 'Co-Founder & Product Manager @ Gravity',
    title: 'Designing data powered outreach tools',
    subtitle: '',
    speakingDate: '',
    linkedinURL: 'https://www.linkedin.com/in/rossegates/',
    photoFileName: 'ross.jpeg',
    datePretty: '',
    daysLeft: 0,
    speakerStatus: 0,
    cardColor: 'background-color:#4C70E6;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 2,
    name: 'Bryan Colligan',
    position: 'Co-Founder & CTO @ Gravity',
    title: '3x Founder, Growth Hacker & Marketer',
    subtitle: '',
    speakingDate: '',
    linkedinURL: 'https://www.linkedin.com/in/bryancolligan/',
    photoFileName: 'bryan-purple.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    cardColor: 'background-color:#3B62E3;box-shadow: 2px 10px 15px grey;',
  },
  {
    id: 3,
    name: 'Jody Kung',
    position: 'Content Editor & Social Media @ Gravity',
    title: 'Student @ UConn School of Business',
    subtitle: '',
    speakingDate: '',
    linkedinURL: 'https://www.linkedin.com/in/jodykung/',
    photoFileName: 'jody.jpeg',
    datePretty: '',
    daysLeft: 1,
    speakerStatus: 2,
    cardColor: 'background-color:#2954E0;box-shadow: 2px 10px 15px grey;',
  },
]

